@if (isLoading$ | async) {
    <div class="spinner-container mb-3 flex-row justify-center items-center">
        <mat-progress-spinner color="accent" mode="indeterminate" diameter="30" class="self-center"></mat-progress-spinner>
    </div>
} @else {
    @if (data) {
        <div class="flex-col gap-16">
            <div class="flex-row">
                <strong class="flex-40 nova__label">Previous Charge Experience:</strong>
                <span class="flex-60" data-qa-id="an_rjd_previousChargeExperience_readonly">
                    <nova-job-qualifications-required-type-change [change]="data.previousChargeExpRequiredTypeId"></nova-job-qualifications-required-type-change>
                </span>
            </div>

            <div class="flex-row">
                <strong class="flex-40 nova__label">Years of Experience:</strong>
                <div class="flex-60" data-qa-id="an_rjd_yearOfExperience_readonly">
                    <nova-job-qualifications-years-of-exp-change [change]="data.yearsOfExp" [noteChange]="data.yearsOfExpNote"></nova-job-qualifications-years-of-exp-change>
                </div>
            </div>

            <div class="flex-row">
                <strong class="flex-40 nova__label">Patient Ratio Experience:</strong>
                <span class="flex-60" data-qa-id="an_rjd_patientRatioExperience_readonly">
                    <nova-job-qualifications-patient-ratio-change [change]="data.patientRatioExp"></nova-job-qualifications-patient-ratio-change>
                </span>
            </div>

            <div class="flex-row">
                <strong class="flex-40 nova__label">Charting System:</strong>
                <span class="flex-60" data-qa-id="an_rjd_chartingSystemName_readonly">
                    <nova-job-qualifications-charting-system-change [change]="data.chartingRequiredTypeAndSystemName"></nova-job-qualifications-charting-system-change>
                </span>
            </div>

            <div class="flex-row">
                <strong class="flex-40 nova__label">Teaching Hospital Experience:</strong>
                <span class="flex-60" data-qa-id="an_rjd_teachingHospitalExperience_readonly">
                    <nova-job-qualifications-required-type-change [change]="data.teachingHospExpRequiredTypeId"></nova-job-qualifications-required-type-change>
                </span>
            </div>

            <div class="flex-row">
                <strong class="flex-40 nova__label">Community Hospital Experience:</strong>
                <span class="flex-60" data-qa-id="an_rjd_communityHospitalExperience_readonly">
                    <nova-job-qualifications-required-type-change [change]="data.communityHospExpRequiredTypeId"></nova-job-qualifications-required-type-change>
                </span>
            </div>

            <div class="flex-row">
                <strong class="flex-40 nova__label">LTAC Experience:</strong>
                <span class="flex-60" data-qa-id="an_rjd_ltacExperience_readonly">
                    <nova-job-qualifications-required-type-change [change]="data.ltacExpRequiredTypeId"></nova-job-qualifications-required-type-change>
                </span>
            </div>

            <div class="flex-row">
                <strong class="flex-40 nova__label">Trauma Level I Experience:</strong>
                <span class="flex-60" data-qa-id="an_rjd_traumaLevelIExperience_readonly">
                    <nova-job-qualifications-required-type-change [change]="data.traumaLevelIExpRequiredTypeId"></nova-job-qualifications-required-type-change>
                </span
              >
            </div>

            <div class="flex-row">
                <strong class="flex-40 nova__label">Trauma Level II Experience:</strong>
                <span class="flex-60" data-qa-id="an_rjd_traumaLevelIIExperience_readonly">
                    <nova-job-qualifications-required-type-change [change]="data.traumaLevelIIExpRequiredTypeId"></nova-job-qualifications-required-type-change>
                </span>
            </div>

            <div class="flex-row">
                <strong class="flex-40 nova__label">Travel Experience Required:</strong>
                <div class="flex-60 capitalize" data-qa-id="an_rjd_travelExperienceRequired_readonly">
                    <nova-job-qualifications-required-type-change [change]="data.travelExpRequiredTypeId" [noteChange]="data.travelExpNote"></nova-job-qualifications-required-type-change>
                </div>
            </div>

            @if (shouldShowStateLicenseField) {
                <div class="flex-row">
                    <strong class="flex-40 nova__label">State License:</strong>
                    <div class="flex-60 capitalize" data-qa-id="an_rjd_stateLicenseRequired_readonly">
                        <nova-job-qualifications-required-type-change [change]="data.stateLicenseRequiredTypeId"></nova-job-qualifications-required-type-change>
                    </div>
                </div>
            }

            <div class="flex-row">
                <div class="flex-40">
                    <strong class="nova__label">Certifications:</strong>
                    <br />
                    <span class="note">Certs marked with * are preferred</span>
                </div>
                <span class="flex-60" data-qa-id="an_rjd_certifications_readonly">
                    @if (showAltCertsComparison()) {
                        <nova-job-qualifications-certs-change [certs]="data.certifications" [altCerts]="data.alternativeCertifications"></nova-job-qualifications-certs-change>
                    } @else {
                        <nova-job-qualifications-certs-change [certs]="data.certifications"></nova-job-qualifications-certs-change>
                    }
                </span>
            </div>

            <div class="flex-row">
                <div class="flex-40">
                    <strong class="nova__label">Skills:</strong>
                    <br />
                    <span class="note">Skills marked with * are preferred</span>
                </div>
                <div class="flex-60" data-qa-id="an_rjd_skills_readonly">
                    <nova-job-qualifications-skills-change [skills]="data.skills"></nova-job-qualifications-skills-change>
                </div>
            </div>
        </div>
    }
}
